"use client";

import {
  FolderOpen,
  Hammer,
  LayoutGrid,
  Phone,
  Users,
} from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import { cn } from "@/lib/utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../dialog";
import { Marketing360Form } from "../Marketing360Form";

const FORM_TITLE = "Request A Consultation Today!";

const NAV_ITEMS = [
  { label: "Services", href: "/services", icon: Hammer },
  { label: "Projects", href: "/projects", icon: FolderOpen },
  { label: "Floor Plans", href: "/floor-plans", icon: LayoutGrid },
  { label: "About", href: "/about", icon: Users },
] as const;

export default function BottomNavBar() {
  const pathname = usePathname();
  const [dialogIsOpen, setDialogIsOpen] = React.useState(false);

  const handleOnOpenChange = React.useCallback(() => {
    setDialogIsOpen(value => !value);
  }, []);

  return (
    <>
      <Dialog open={dialogIsOpen} onOpenChange={handleOnOpenChange}>
        <DialogContent className="bg-card max-w-2xl">
          <DialogHeader>
            <DialogTitle>{FORM_TITLE}</DialogTitle>
          </DialogHeader>

          <Marketing360Form />
        </DialogContent>
      </Dialog>

      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t bg-background pb-[env(safe-area-inset-bottom)] md:hidden">
        <div className="flex items-center justify-around px-2">
          {/* First two items */}
          {NAV_ITEMS.slice(0, 2).map(item => (
            <Link
              key={item.label}
              href={item.href}
              className={cn(
                "flex flex-1 flex-col items-center gap-0.5 py-2 text-xs transition-colors",
                pathname.startsWith(item.href)
                  ? "text-primary"
                  : "text-muted-foreground",
              )}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          ))}

          {/* Center FAB */}
          <div className="flex flex-1 items-center justify-center">
            <button
              type="button"
              onClick={handleOnOpenChange}
              className="flex -mt-4 h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform active:scale-95"
            >
              <Phone className="h-6 w-6" />
            </button>
          </div>

          {/* Last two items */}
          {NAV_ITEMS.slice(2).map(item => (
            <Link
              key={item.label}
              href={item.href}
              className={cn(
                "flex flex-1 flex-col items-center gap-0.5 py-2 text-xs transition-colors",
                pathname.startsWith(item.href)
                  ? "text-primary"
                  : "text-muted-foreground",
              )}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </>
  );
}
